import type { CrossFlowExtensions } from '@atlassiansox/cross-flow-base-types';
import { type EditionExtensionsOptions } from './types';
import { createProductExtensions } from './utils';

export { Editions } from './types';
export type { EditionExtensionsOptions } from './types';

export const editionExtensionsWhitelist: string[] = ['edition'];

export const createEditionExtensions: (options: EditionExtensionsOptions) => CrossFlowExtensions =
	createProductExtensions<EditionExtensionsOptions>(editionExtensionsWhitelist);
